<script>
  import options from './HighchartGraph.options'
  export default options
</script>

<template>
  <article class="nyk-highchart-graph">
    <div :id="graphUniqueId"></div>
  </article>
</template>
